export function getTimezoneName(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/**
 * Offset in minutes, positive or negative, matching the sign convention
 * the backend expects (east of UTC is positive).
 */
export function getTimezoneOffsetMinutes(): number {
  return -new Date().getTimezoneOffset()
}
